let _ = require("ES/lib/lodash");
let Balboa = require("ES/services/Balboa");
let esUtils = require("ES/utils/esUtils");
let RadioService = require("ES/lib/react-pubsub-via-radio.js/service");

module.exports.init = function(){
	RadioService("TripIt_get_list", function(params, callback){
		Balboa.api("/event/returntripitlist", {
		}, function(data){
			callback(null, _.mapValues(_.groupBy(data.data, "sid"), function(group){
				return _.map(group, function(v){
					if(v.failed){
						return {failed: v.failed};
					}
					return {
						id: v.tripid,//don't parseInt b/c the tripit api may use strings not numbers
						description: v.tripdescription
					};
				});
			}));
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	}, function(){
		return 1;
	});

	RadioService("TripIt_get_plans", function(params, callback){
		Balboa.api("/event/returntripitplans", {
			sid: params.sid,
			tripid: params.tripid
		}, function(data){
			var r = {};
			_.each(["Flight", "Hotel", "Ground"], function(key){
				r[key] = _.map(data.data[key], esUtils.convertBalboa3ToJS[key]);
			});
			callback(null, r);
		}, function(data){
			callback((data && data.message) || "unknown cause");
		});
	});
};



// WEBPACK FOOTER //
// ./src/services/TripIt.js